import { useContext, useEffect, useRef } from 'react'
import { useNavigate } from 'react-router-dom'

import { ConsentContext } from '@context/ConsentContext'
import { SurveyContext } from '@context/SurveyContext'
import { SurveyStep } from '@models/Survey/SurveyStep'
import { Pages } from '@models/Pages'
import { isAdminPreviewSession } from './applyAdminPreviewQuery'

/**
 * In Admin 2.0 playground iframe: skip ConsentPage UI and mint a tagged visitor session
 * (is_admin_preview + admin_username) so analytics can exclude dummy data by default.
 */
export function AdminPreviewAutoConsent() {
  const navigate = useNavigate()
  const { sendConsents } = useContext(ConsentContext)
  const { survey, setNextStep } = useContext(SurveyContext)
  const startedRef = useRef(false)

  useEffect(() => {
    if (!isAdminPreviewSession()) return
    if (!survey?.id || startedRef.current) return
    startedRef.current = true
    // Always create a fresh tagged visitor (do not reuse a prior real consent from storage).
    void sendConsents(survey.id).then(() => {
      // Keep SurveyContext step in sync with the URL — SurveyLayout navigates from `step`
      // and would otherwise bounce Answer → Sandbox in a loop (image overlay flicker).
      setNextStep(SurveyStep.Answer)
      navigate(`/${Pages.Survey}/${SurveyStep.Answer}`, { replace: true })
    })
  }, [navigate, sendConsents, setNextStep, survey?.id])

  return null
}

export default AdminPreviewAutoConsent
